import { render, staticRenderFns } from "./message_list_m.vue?vue&type=template&id=e73646b4&scoped=true&"
import script from "./message_list_m.vue?vue&type=script&lang=js&"
export * from "./message_list_m.vue?vue&type=script&lang=js&"
import style0 from "./message_list_m.vue?vue&type=style&index=0&id=e73646b4&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e73646b4",
  null
  
)

export default component.exports